import { init } from '@sentry/react';
import { getRegisterConfig } from '@golden/sentry-base';
export const registerSentry = (options) => {
    const { ignoreErrors = [] } = options;
    init({
        ...getRegisterConfig(options),
        tracesSampleRate: 0.001,
        ignoreErrors
    });
};
//# sourceMappingURL=registerSentry.js.map